import React, {useEffect, useState} from "react";
import Loading from "../../../Loading";
import {Button, ButtonGroup, Col, FormControl, Glyphicon, Row, Table} from "react-bootstrap";
import PaginationBar from "../../../PaginationBar";
import moment from "moment";
import OwnerEditor from "./OwnerEditor";
import {certificateGetOwners, clientCertificateSendMail} from "api";
import {useEventContext} from "../../../../context";

function getOwnerStatus({isQueued, sentAt}) {
    if (!isQueued) {
        return 'Нет';
    }

    if (!sentAt) {
        return 'В очереди';
    }

    return moment.unix(sentAt).format('YYYY-MM-DD HH:mm:ss');
}

export default () => {
    const {event} = useEventContext();
    const [owners, setOwners] = useState(null);
    const [pageNumber, setPageNumber] = useState(1);
    const [editRegistrationId, setEditRegistrationId] = useState(null);
    const [filterByEmail, setFilterByEmail] = useState('');
    const [filterByStatus, setFilterByStatus] = useState('');
    const pageSize = 100;

    useEffect(() => {
        certificateGetOwners(event.eventPassword)
            .then(owners => setOwners(owners));
    }, []);

    const handleMailBroadcast = () =>
    {
        clientCertificateSendMail(event.eventPassword)
            .then(() => alert('Письма будут разосланы в ближайшее время'))
            .catch(() => alert('При отправке писем произошла ошибка'))
        ;
    }

    const handleMailListBroadcast = (list) =>
    {
        const email = list.map(({email}) => email);

        clientCertificateSendMail(event.eventPassword, email)
            .then(() => alert('Письма будут разосланы в ближайшее время'))
            .catch(() => alert('При отправке писем произошла ошибка'))
        ;
    }

    const showOwnerEditor = (editRegistrationId) =>
    {
        setEditRegistrationId(editRegistrationId);
    }

    const hideOwnerEditor = () =>
    {
        setEditRegistrationId(null);
    }

    if (null === owners) {
        return <Loading />;
    }

    const filtersByStatus = {
        sent: ({sentAt}) => sentAt > 0,
        isQueued: ({isQueued}) => isQueued,
        notSent: ({isQueued}) => !isQueued,
    };

    let ownersFiltered = owners;

    if (filterByEmail) {
        ownersFiltered = ownersFiltered.filter(owner => owner.email.indexOf(filterByEmail) >= 0);
    }

    if (filterByStatus) {
        ownersFiltered = ownersFiltered.filter(filtersByStatus[filterByStatus]);
    }

    const pageCount = Math.ceil(ownersFiltered.length / pageSize);

    ownersFiltered = ownersFiltered.slice((pageNumber - 1) * pageSize, pageNumber * pageSize);

    return (
        <section className="clientCertificate-owners">
            <Row>
                <Col style={{textAlign: 'right'}}>
                    <Button onClick={handleMailBroadcast}>Отправить письма зрителям</Button>
                </Col>
            </Row>

            <Table responsive>
                <thead>
                <tr>
                    <th>Email</th>
                    <th width="160">Письмо отправлено</th>
                    <th width="180" />
                </tr>
                <tr>
                    <th>
                        <FormControl
                            type="text"
                            value={filterByEmail}
                            onChange={(e) => setFilterByEmail(e.target.value)}
                        />
                    </th>
                    <th>
                        <FormControl
                            componentClass="select"
                            value={filterByStatus}
                            onChange={(e) => setFilterByStatus(e.target.value)}
                        >
                            <option value="">Все</option>
                            <option value="sent">Отправлено</option>
                            <option value="isQueued">В очереди</option>
                            <option value="notSent">Не отправлено</option>
                        </FormControl>
                    </th>
                    <th />
                </tr>
                </thead>
                <tbody>
                {ownersFiltered.map((owner, index) => (
                    <tr key={`clientCertificateOwner_${owner.email}_${index}`}>
                        <td>{owner.email}</td>
                        <td>{getOwnerStatus(owner)}</td>
                        <td style={{textAlign: 'right'}}>
                            <Button bsSize="small" href={`/event/${event.eventKey}/certificate/${owner.registrationId}?download=0`} target="_blank">
                                <Glyphicon glyph="picture" />
                            </Button>
                            {' '}
                            <ButtonGroup>
                                <Button bsSize="small" title="" onClick={() => showOwnerEditor(owner.registrationId)}><Glyphicon glyph="cog" /></Button>
                                <Button bsSize="small" title="" onClick={() => handleMailListBroadcast([owner])}><Glyphicon glyph="envelope" /></Button>
                            </ButtonGroup>
                        </td>
                    </tr>
                ))}
                </tbody>
            </Table>

            <PaginationBar
                pageCount={pageCount}
                activePage={pageNumber}
                onSelect={setPageNumber}
            />

            <OwnerEditor event={event} registrationId={editRegistrationId} onHide={hideOwnerEditor} />
        </section>
    );
}
